import { Grid, TextareaAutosize } from '@material-ui/core';
import {
  DateRange,
  Description as DescriptionIcon,
  DriveEta,
  Euro as EuroIcon,
  Favorite,
  FavoriteBorder,
  Language as LanguageIcon,
  PlaylistAdd,
  Schedule,
  LocationOn as LocationOnIcon,
  SchoolRounded as SchoolIcon,
  SettingsBackupRestore as SettingsBackupRestoreIcon,
  VerifiedUser as VerifiedUserIcon,
  WatchLater as WatchLaterIcon,
} from '@material-ui/icons';
import Home from '@material-ui/icons/Home';
import {
  checkIfPostuleOffer,
  checkIfSavedOffer,
  getInfosDashboard,
  postuleOffer,
  savedOffer,
  unSavedOffer,
} from '@webapps/business';
import {
  Button,
  useAuth,
  useMutation,
  useQuery,
  useToast,
} from '@webapps/reactjs-tech-components';
import { useStyles } from '@webapps/styles';
import PermisIcon from 'components/Icons/PermisIcon';
import theme from 'pages/MyMap/theme';
import PropTypes from 'prop-types';
import { useEffect } from 'react';
import { FormattedDate, FormattedMessage } from 'react-intl';
import parse from 'html-react-parser'
import HourglassHalf from 'components/Icons/HourglassHalf';

const {
  colors: { background },
} = theme;

const DetailsAnnonce = ({ info = {} }) => {
  const {
    classes,
    css,
    global,
    cx,
    theme: { spacing },
  } = useStyles(styles);

  const { profile } = useAuth();
  const { idUser } = useAuth();

  const { addToast } = useToast();

  const {
    isLoading: isLoadingSavedOffer,
    isSuccess: isSuccessSave,
    mutateAsync: mutateSavedOffer,
  } = useMutation(savedOffer);

  const {
    isLoading: isLoadingPostuleOffer,
    isSuccess: isSuccessPostule,
    mutateAsync: mutatePostuleOffer,
  } = useMutation(postuleOffer);

  const {
    isLoading: isLoadingUnSavedOffer,
    isSuccess: isSuccessUnSave,
    mutateAsync: mutateUnSavedOffer,
  } = useMutation(unSavedOffer);

  const { data: checkSave = {}, refetch } = useQuery(checkIfSavedOffer, {
    key: ['checkSavedOffer'] + idUser + info?.id,
    variables: { idApplicant: idUser, idOffer: info?.id },
  });

  const { data: checkPostule = {}, refetch: refetchPostule } = useQuery(
    checkIfPostuleOffer,
    {
      key: ['checkPostuleOffer'] + idUser + info?.id,
      variables: { idApplicant: idUser, idOffer: info?.id },
    }
  );

  const { data: infosBusiness = {}, refetch: refetchInfosBusiness } = useQuery(getInfosDashboard, {
    key: 'infoDashboardBusiness',
    variables: { id: info?.business?.id },
  });

  useEffect(() => {
    refetchInfosBusiness();
  }, [info.business?.id])


  useEffect(() => {
    if (isSuccessSave) {
      addToast({
        status: 'success',
        message: 'Offre sauvegardée',
      });
    }
    refetch();
  }, [isSuccessSave]);

  useEffect(() => {
    if (isSuccessPostule) {
      addToast({
        status: 'success',
        message: 'Vous avez postulé à l\'offre',
      });
    }
    refetchPostule();
  }, [isSuccessPostule]);

  useEffect(() => {
    if (isSuccessUnSave) {
      addToast({
        status: 'success',
        message: 'Offre retiré des sauvegardes',
      });
    }
    refetch();
  }, [isSuccessUnSave]);

  const saveOffer = async () => {
    await mutateSavedOffer({
      data: {
        applicant: {
          id: idUser,
        },
        offer: {
          id: info?.id,
        },
      },
    });
  };

  const postOffer = async () => {
    await mutatePostuleOffer({
      data: {
        applicant: {
          id: idUser,
        },
        offer: {
          id: info?.id,
        },
      },
    });
  };

  const unSaveOffer = async () => {
    await mutateUnSavedOffer({
      idApplicant: idUser,
      idOffer: info?.id,
    });
  };

  return (
    <div className={classes.container}>
      <div className={cx(global.title, classes.title)}><p style={{ margin: 0 }}>Informations pratiques:</p></div>
      <div style={{ marginBottom: '20px' }}>
        <Grid container>
          <Grid item className={classes.paddingBottomMobile}>
            <div className={classes.info}>
              <SchoolIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="levelDiplome" /> :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.degreeLevel?.label}
              </div>
            </div>
            <div className={classes.info}>
              <LocationOnIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Adresse :
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.address?.label}
              </div>
            </div>
            <div className={classes.info}>
              <DescriptionIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="typeContrate" /> :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.contractType?.label}
              </div>
            </div>
            <div className={classes.info}>
              <EuroIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="salaire" /> :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.salary} €/mois
              </div>
            </div>
            <div className={classes.info}>
              <HourglassHalf className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="dureeContrat" /> :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.contractLength} mois
              </div>
            </div>
            {info?.jobAdvantages.length < 0 &&
              <div
                className={css({
                  marginBottom: spacing(2),
                  display: 'flex',
                  flexDirection: 'column',
                })}
              >
                <div
                  className={css({
                    display: 'flex',
                  })}
                >
                  <PlaylistAdd className={cx(global.infoIcon, classes.icon)} />
                  <div

                  >
                    Avantages :{' '}
                  </div>
                </div>
                <div className={css({ marginTop: spacing(1) })}>
                  {info?.jobAdvantages?.map(({ label }, index) => (
                    <li key={index}>{label}</li>
                  ))}
                </div>
              </div>
            }
            <div className={classes.info}>
              <LanguageIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                <FormattedMessage id="langRequis" /> :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.workedLangage?.map(({ label }) => `${label} `)}
              </div>
            </div>
            <div className={classes.info}>
              <DriveEta className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Être véhiculé :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.transport ? 'Oui' : 'Non'}
              </div>
            </div>
            <div className={classes.info}>
              <PermisIcon className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Type de permis :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.drivingLicence === 'non'
                  ? 'Aucun'
                  : info?.drivingLicence}
              </div>
            </div>
            <div className={classes.info}>
              <Home className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Présence :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                {info?.telework}
              </div>
            </div>
            <div className={classes.info}>
              <DateRange className={cx(global.infoIcon, classes.icon)} />
              <div className={cx(global.infoText, classes.text)}>
                Dépot de candidature :{' '}
              </div>
              <div style={{ marginLeft: '4px' }}>
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={info?.applicationStartDate}
                  year="numeric"
                />{' '}
                au{' '}
                <FormattedDate
                  day="numeric"
                  month="numeric"
                  value={info?.applicationClosingDate}
                  year="numeric"
                />
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
      <div className={classes.textContainer}>
        <div className={cx(global.title, classes.title)}><p style={{ margin: 0 }}>Description:</p></div>
        {info?.description !== ' ' ? (
          <div className={classes.modifyLink}>{parse(info?.description)}</div>
        ) : (
          <div>Pas de description</div>
        )}
        {infosBusiness.profile?.presentation &&
          <div className={classes.textContainer}>
            <div className={cx(global.title, classes.title)}><p style={{ margin: 0 }}>Qui sommes-nous ?</p></div>
            <div className={classes.modifyLink}>{parse(infosBusiness.profile.presentation)}</div>
          </div>
        }
        {profile === 'INDIVIDUAL' && (
          <div className={css({ marginBottom: spacing(1) })}>
            <Grid container spacing={3}>
              <Grid item xs={5}>
                {checkPostule ? (
                  <Button
                    className={css({ borderRadius: 20 })}
                    color="primary"
                    disabled
                    fullWidth
                    variant="contained"
                  >
                    Déjà postulé
                  </Button>
                ) : (
                  <Button
                    className={css({ borderRadius: 20 })}
                    color="primary"
                    disabled={isLoadingPostuleOffer}
                    fullWidth
                    onClick={postOffer}
                    variant="contained"
                  >
                    Postuler
                  </Button>
                )}
              </Grid>
              <Grid item xs={5}>
                {checkSave ? (
                  <Button
                    className={css({ borderRadius: 20 })}
                    disabled={isLoadingUnSavedOffer}
                    fullWidth
                    onClick={unSaveOffer}
                    startIcon={<Favorite />}
                    variant="outlined"
                  >
                    <FormattedMessage id="AddedToFavorite" />
                  </Button>
                ) : (
                  <Button
                    className={css({ borderRadius: 20 })}
                    disabled={isLoadingSavedOffer}
                    fullWidth
                    onClick={saveOffer}
                    startIcon={<FavoriteBorder />}
                    variant="outlined"
                  >
                    <FormattedMessage id="AddToFavorite" />
                  </Button>
                )}
              </Grid>
            </Grid>
          </div>
        )}
      </div>
    </div>
  );
};

const styles = ({ spacing }) => ({
  container: {
    borderRadius: 10,
    background,
    color: '#152652',
  },
  icon: {
    color: '#0060F9',
  },
  text: {
    color: '#152652',
    fontWeight: 600,
  },
  title: {
    borderTop: '1px solid #C0D9FF',
    paddingTop: spacing(2.5),
    '& p': {
      borderLeft: '3px solid #0060F9',
      paddingLeft: spacing(1)
    },
  },
  textContainer: {
    '& > *': {
      textAlign: 'justify',
    },
  },
  info: {
    marginTop: spacing(2),
    display: 'flex',
    alignItems: 'center',
  },
  paddingTopMobile: {
    '@media screen and (max-width: 768px)': {
      paddingTop: '0 !important'
    }
  },
  paddingBottomMobile: {
    '@media screen and (max-width: 768px)': {
      paddingBottom: '0 !important'
    }
  }
});

DetailsAnnonce.propTypes = {
  info: PropTypes.object,
};

export default DetailsAnnonce;
